import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTxnCashTransactionListPageUI from './ClientTxnCashTransactionListPageUI.js'

class ClientTxnCashTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      account: null,
      transactionList: null,
      // pagination
      lastKey: null,
      hasMore: true,
      gettingMore: false,
    }
  }

  render() {
    return (
      <ClientTxnCashTransactionListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        transactionList={this.state.transactionList}
        yearMonth={this.state.yearMonth}
        category={this.props.match.params.category}
        hasMore={this.state.hasMore}
        gettingMore={this.state.gettingMore}
        onMoreTransactions={this.onMoreTransactions}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getClientTxnCashTxns(context)
    this.getAccounts(context)
  }

  getClientTxnCashTxns(context) {
    let params = this.props.match.params
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${params.accountId}/` +
        `clientTxnCats/${params.category}/year/${params.year}/month/${params.month}/transactions`,
      cacheKey: CacheKeys.ClientTxnCashTxns(params.accountId, params.category, params.year, params.month),
      callback: this.getClientTxnCashTxnsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context, null, {
      limit: 1000
    })
  }

  getClientTxnCashTxnsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      transactionList: response.transactionList,
      yearMonth: response.yearMonth,
      lastKey: response.lastKey,
      hasMore: response.hasMore,
    })
  }

  onMoreTransactions = () => {
    let context = this.props.context
    this.setState({gettingMore: true})
    let params = this.props.match.params

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${params.accountId}/` +
        `clientTxnCats/${params.category}/year/${params.year}/month/${params.month}/transactions`,
      cacheKey: CacheKeys.ClientTxnCashTxns(params.accountId, params.category, params.year, params.month),
      callback: this.onMoreTransactionsCallback,
      ttlInSecs: 0
    })

    let limit = 1000
    if (this.state.transactionList.length === 100)
      limit = 900
    cacheManager.getObject2(context, null,
      {
        limit: limit,
        evaluatedKey: this.state.lastKey
      }
    )
  }

  onMoreTransactionsCallback = (response) => {
    let context = this.props.context
    let transactionList = this.state.transactionList
    transactionList = transactionList.concat(response.transactionList)

    this.setState({
      errorList: response.errorList,
      transactionList: transactionList,
      currentPage: response.currentPage,
      hasMore: response.hasMore,
      gettingMore: false
    })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({account : response.account})
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    let params = this.props.match.params
    CacheManager.removeObject(CacheKeys.ClientTxnCashTxns(params.accountId, params.category, params.year, params.month))
    if (noBusy === 'noBusy') {
      this.getClientTxnCashTxns(context)
    }
    else {
      this.setState({
        transactionList: null,
        errorList: null,
      }, () => {
        this.getClientTxnCashTxns(context)
      })
    }
  }
}

export default withRouter(ClientTxnCashTransactionListPageSF)
